import createStandartGermanDateWithTime from "scripts/createStandartGermanDateWithTime"

export const SendApiRequest = ({
  ticketText,
  phoneNumber,
  companyName,
  mailAddress,
  targetInbox,
  ticketSubject,
  launchModal,
  recallTime,
  customerName,
}) => {
  const finishedEmail = !!recallTime
    ? "<ul><li> Name: " +
      customerName +
      "</li><li> Telefon: " +
      phoneNumber +
      "</li><li> Firma: " +
      companyName +
      "</li><li> Wunschtermin: " +
      createStandartGermanDateWithTime(recallTime) +
      "</li></ul>"
    : ticketText +
      "<br /><ul><li> Telefon: " +
      phoneNumber +
      "</li><li> Firma: " +
      companyName +
      "</li></ul>"

  const finishedSubject =
    ticketSubject ||
    "Rückrufwunsch von " +
      customerName +
      `${companyName && `, Firma: ${companyName}`}` +
      ", für: " +
      new Intl.DateTimeFormat("de-DE", {
        dateStyle: "full",
        timeStyle: "short",
      })
        .format(new Date(recallTime))
        .toString()

  fetch(
    `https://europe-west3-biwebsite.cloudfunctions.net/create_support_ticket`,
    {
      method: "POST",
      body: JSON.stringify({
        body: finishedEmail,
        from: mailAddress || "rueckruf@bi-medien.de",
        to: targetInbox,
        subject: finishedSubject,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    }
  )
    .then((response) => {
      response.ok ? launchModal(true) : launchModal(false)
    })
    .catch((error) => {
      launchModal(false)
    })
}
